import { useAppSelector } from 'app/hooks';
import clsx from 'clsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { selectInverterItemSidebar } from '../Sidebar/sidebarSlice';
import style from './Header.module.scss';
export interface HeaderInverterProps {}

export default function HeaderInverter(props: HeaderInverterProps) {
  const inverterItemSelected = useAppSelector(selectInverterItemSidebar);
  const { t } = useTranslation();
  const [isValueNav, setIsValueNav] = React.useState<number>(1);
  const setParamsItemNavbar = (number: number) => {
    setIsValueNav(number);
    localStorage.setItem('isValueNavInverter', number.toString());
  };
  React.useEffect(() => {
    let newNumber = localStorage.getItem('isValueNavInverter');
    setIsValueNav(Number(newNumber));
  }, [inverterItemSelected]);
  return (
    <>
      <Link key={1} to={`/inverter/home/${inverterItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(1)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 1,
          })}
        >
          {t('content.home')}
        </div>
      </Link>
      <Link key={2} to={`/inverter/alarm/${inverterItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(2)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 2,
          })}
        >
          {t('content.alarm')}
        </div>
      </Link>
      <Link key={3} to={`/inverter/parameter/${inverterItemSelected}`}>
        <div
          onClick={() => setParamsItemNavbar(3)}
          className={clsx(style.btn_nav_menu, {
            [style.active]: isValueNav === 3,
          })}
        >
          {t('content.parameter')}
        </div>
      </Link>
    </>
  );
}
